module.exports = __webpack_public_path__ + "static/media/v40.b7d1594a.mp4";